// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingSpaceTypePanel_root__1z1si","form":"EditListingSpaceTypePanel_form__21xra","title":"EditListingSpaceTypePanel_title__14WvY"};